export default function Toast({ toast }) {
  return (
    <>
      <div className={`toast${toast ? ' show' : ''}`}>
        <span>{toast?.icon || '✅'}</span>
        <span>{toast?.msg}</span>
      </div>
      <style>{`
        .toast{position:fixed;bottom:24px;right:24px;background:var(--bg2);border:1px solid var(--border2);border-radius:10px;padding:12px 16px;display:flex;align-items:center;gap:10px;font-size:14px;font-weight:500;z-index:300;transform:translateY(70px);opacity:0;transition:all .3s cubic-bezier(.34,1.56,.64,1);pointer-events:none;min-width:240px}
        .toast.show{transform:translateY(0);opacity:1}
        @media (max-width:480px){.toast{left:12px;right:12px;bottom:12px;min-width:0}}
      `}</style>
    </>
  );
}
